import { Component, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';

export interface LogifitConfirmAction {
  id: string;
  text: string;
  danger?: boolean;
  role?: 'cancel';
}

export interface LogifitConfirmOptions {
  title: string;
  message?: string;
  actions: LogifitConfirmAction[];
}

@Component({
  selector: 'app-logifit-modal-confirm',
  templateUrl: './logifit-modal-confirm.component.html',
  styleUrls: ['./logifit-modal-confirm.component.scss']
})
export class LogifitModalConfirmComponent {
  @ViewChild('modal') modal: IonModal;

  title = '';
  message = '';
  actions: LogifitConfirmAction[] = [];

  private resolvePresent?: (actionId: string | null) => void;
  private settled = false;

  async present(options: LogifitConfirmOptions): Promise<string | null> {
    this.title = options.title;
    this.message = options.message ?? '';
    this.actions = options.actions;
    this.settled = false;

    await this.modal.present();

    return new Promise<string | null>((resolve) => {
      this.resolvePresent = resolve;
    });
  }

  choose(actionId: string): void {
    this.finish(actionId);
  }

  dismiss(): void {
    this.finish(null);
  }

  onDidDismiss(): void {
    if (!this.settled) {
      this.finish(null);
    }
  }

  private finish(actionId: string | null): void {
    if (this.settled) {
      return;
    }

    this.settled = true;
    const resolve = this.resolvePresent;
    this.resolvePresent = undefined;
    void this.modal.dismiss();
    resolve?.(actionId);
  }
}
